export const Weekdayconverter = (input: string ) => {
    if (input === 'lundi') {
        return 'monday'
    } else if (input === 'mardi') {
        return 'tuesday'
    }else if (input === 'mercredi') {
        return 'wednesday'
    } else if (input === 'jeudi') {
        return 'thursday'
    } else if (input === 'vendredi') {
        return 'friday'
    } else if (input === 'samedi') {
        return 'saturday'
    } else if (input === 'dimanche') {
        return 'sunday'
    }  




    else if (input === 'monday') {
        return 'lundi'
    } else if (input === 'tuesday') {
        return 'mardi'
    }else if (input === 'wednesday') {
        return 'mercredi'
    } else if (input === 'thursday') {
        return 'jeudi'
    } else if (input === 'friday') {
        return 'vendredi'
    } else if (input === 'saturday') {
        return 'samedi'
    } else if (input === 'sunday') {
        return 'dimanche'
    }  
} 